import { Feature, Permission } from 'src/WebApiController';

import { useUserHasAnyOfPermissions } from '../useUserHasAnyOfPermissions';
import { useUserHasFeature } from '../useUserHasFeature';
import { ReportConfigV2 } from './useReportConfigsV2Internal';

export const useReportPermissions = (reportConfig?: ReportConfigV2) => {
  const hasReportingV2Feature = useUserHasFeature(Feature.ReportingV2);
  const hasReportSinglePagedV1V2Feature = useUserHasFeature(
    Feature.ReportSinglePagedV1V2
  );

  const hasViewReportPermissions = useUserHasAnyOfPermissions(
    Permission.Reports_ViewAll,
    Permission.Reports_ViewGlobalReports,
    Permission.Reports_ViewInventoryReports,
    Permission.Reports_ViewSalesReports,
    Permission.Reports_ViewSharedReports
  );

  const hasUpdateOwnReportPermission =
    useUserHasAnyOfPermissions(
      Permission.Reports_UpdateReportsOwned,
      Permission.Reports_UpdateReports
    ) &&
    (reportConfig?.isOwner ?? false);

  const isGlobalReport = reportConfig?.globalReportTypeId !== undefined;

  const canUpdateReport =
    reportConfig != null && hasUpdateOwnReportPermission && !isGlobalReport;

  const hasAccessToReportingV2 =
    hasReportingV2Feature &&
    hasViewReportPermissions &&
    !hasReportSinglePagedV1V2Feature;

  return {
    canUpdateReport,
    canViewReport: hasViewReportPermissions,
    hasAccessToReportingV2,
    hasReportSinglePagedV1V2Feature,
  };
};
